// src/router/statusProcessoMatriz.js

// Quem abre estas telas (TRI-107; o admin passa). Aplicado pelo guard de @/router/permissoes.js,
// que o menu lateral também usa.
const ROLES = ['coordenador_operacional']

const statusProcessoBreadcrumb = [
  {
    label: 'Home',
    to: 'Home'
  },
  {
    label: 'Status',
    to: 'Status'
  }
]

export default [
  {
    path: '/status/matriz',
    name: 'StatusMatriz',
    component: () => import('@/views/StatusProcesso/StatusProcessoMatrizPage.vue'),
    meta: {
      roles: ROLES,
      title: 'Matriz de Cobertura',
      breadcrumb: [
        ...statusProcessoBreadcrumb,
        {
          label: 'Matriz de Cobertura',
          to: 'StatusMatriz'
        }
      ]
    }
  }
]
